import { defineComponent, computed, ref, h } from '@vue/composition-api';
import { withInstall, isObject } from '../util/index.js';

var Props = {
  value: {
    type: Number,
    "default": 100,
    required: true
  },
  color: {
    type: [String, Object],
    "default": ''
  },
  layerColor: {
    type: String,
    "default": ''
  },
  size: {
    type: [String, Number],
    "default": '100px'
  },
  fill: {
    type: String,
    "default": 'none'
  },
  text: {
    type: String,
    "default": ''
  },
  strokeWidth: {
    type: [String, Number],
    "default": 5
  },
  strokeLinecap: {
    type: String,
    "default": 'round'
  },
  clockwise: {
    type: Boolean,
    "default": true
  },
  speed: {
    type: [String, Number],
    "default": 1000
  },
  start: {
    type: String,
    "default": 'top'
  }
};
var CircleId = 0;
var START_DEG = {
  top: -90,
  left: 180,
  right: 0,
  bottom: 90
};
var Circle = defineComponent({
  name: 'm-circle',
  props: Props,
  setup: function setup(props, context) {
    var id = "m-circle-".concat(++CircleId); // 计算半径周长

    var radius = computed(function () {
      return (100 - Number(props.strokeWidth)) / 2;
    });
    var circumference = computed(function () {
      return 2 * radius.value * Math.PI;
    }); // 计算dashoffset&处理动画

    var animateReady = ref(false);

    try {
      requestAnimationFrame(function () {
        animateReady.value = true;
      });
    } catch (error) {
      animateReady.value = true;
    }

    var dashoffset = computed(function () {
      var symbol = props.clockwise ? 1 : -1;
      if (!animateReady.value) return circumference.value * symbol;
      return (100 - props.value) / 100 * circumference.value * symbol;
    }); // 渐变

    var Gradient = {
      functional: true,
      render: function render(h) {
        if (!isObject(props.color)) {
          return null;
        }

        var Stops = Object.keys(props.color).sort(function (a, b) {
          return parseFloat(a) - parseFloat(b);
        }).map(function (key, index) {
          return h("stop", {
            "key": index,
            "attrs": {
              "offset": key,
              "stop-color": props.color[key]
            }
          });
        });
        return h("defs", [h("linearGradient", {
          "attrs": {
            "id": id,
            "x1": '100%',
            "y1": '0%',
            "x2": '0%',
            "y2": '0%'
          }
        }, [Stops])]);
      }
    }; // 进度槽

    var Groove = {
      functional: true,
      render: function render(h) {
        return h("circle", {
          "class": 'm-circle-groove',
          "attrs": {
            "cx": '50',
            "cy": '50',
            "r": radius.value,
            "fill": props.fill,
            "stroke-width": Number(props.strokeWidth) - 1
          },
          "style": {
            stroke: props.layerColor
          }
        });
      }
    }; // 进度条

    var Bar = {
      functional: true,
      render: function render(h) {
        return h("circle", {
          "class": 'm-circle-bar',
          "attrs": {
            "cx": '50',
            "cy": '50',
            "r": radius.value,
            "fill": 'none',
            "stroke-width": props.strokeWidth,
            "stroke-linecap": props.strokeLinecap,
            "stroke-dasharray": "".concat(circumference.value, ", ").concat(circumference.value),
            "stroke-dashoffset": dashoffset.value
          },
          "style": {
            stroke: isObject(props.color) ? "url(\"#".concat(id, "\")") : props.color,
            transform: "rotateZ(".concat(START_DEG[props.start], "deg)"),
            transformOrigin: 'center',
            transition: "stroke-dashoffset ".concat(props.speed, "ms")
          }
        });
      }
    };
    return function () {
      var _context$slots$defaul, _context$slots;

      return h("div", {
        "class": 'm-circle',
        "style": {
          width: "".concat(props.size),
          height: "".concat(props.size)
        }
      }, [h("svg", {
        "attrs": {
          "viewBox": '0 0 100 100'
        }
      }, [h(Gradient), h(Groove), h(Bar)]), h("div", {
        "class": 'm-circle-inner'
      }, [h("div", {
        "class": 'm-circle-text'
      }, [props.text]), (_context$slots$defaul = (_context$slots = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots)])]);
    };
  }
});
withInstall(Circle);

export { Circle as default };
//# sourceMappingURL=index.js.map
